// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0009 0.833984L18.3729 4.65718L17.3439 6.37216L17.0009 6.16636V8.00017H7.0009V6.16636L6.6579 6.37216L5.62891 4.65718L12.0009 0.833984ZM11 3.99805V6.00195H13.0039V3.99805H11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 10H2V22H8V15H16V22H22V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 17V22H14V17H10Z"}}]};

const Building2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-2-filled',
    ref,
    icon: element,
  },
));

Building2FilledIcon.displayName = 'Building2FilledIcon';

export default Building2FilledIcon;
